import React, { useState } from 'react';
import { Stepper } from './Components/Stepper';
import { FormSection } from './Components/FormSection';
import './styles.scss';
import { Redirect } from 'react-router-dom';

export const NewOrder = ({ height = '100%', isInternal, onClose, onServiceCreate }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const loggedInEmail = localStorage.getItem('user-email');
  if (!isInternal && loggedInEmail) {
    return <Redirect from="/login" to={'/services/pipeline?newOrder=1'} />;
  }

  return (
    <div className="new-order-container" style={{ height }}>
      <Stepper isInternal={isInternal} activeStep={currentStep} />
      <FormSection
        isInternal={isInternal}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onClose={onClose}
        onServiceCreate={onServiceCreate}
      />
    </div>
  );
};
